import styled from 'styled-components';

import {colors} from 'styles';

export const Line = styled.hr`
  border: 0;
  border-top: 1px solid ${colors.border};
  margin: 0;
`;
